function parseResponseData(data) {
  if((!data) || data.length==0){
      return null;
  }
  else {
    return JSON.stringify(data);
  }
}

function parseStarResponseData(data) {
  if((!data) || data.length==0){
      return null;
  }
  else {
    return JSON.stringify(data);
  }
}

function parseUserTypeData(data) {
  if((!data) || data.length==0){
      return null;
  }
  else {
    return JSON.stringify(data);
  }
}

function serviceFactory({ api }) {
  const getResponseJson = ({portfolioId, deviceType, starRating, feedbackCateg,feedbackText,logoutTriggered,clientAdvisorFlag,metaData}) =>
    api
    .getResponseJson(portfolioId, deviceType, starRating, feedbackCateg,feedbackText,logoutTriggered,clientAdvisorFlag,metaData)
    .then(parseResponseData);

  const checkStarFeedback = ({metaData}) =>
    api
    .checkStarFeedback(metaData)
    .then(parseStarResponseData);

   const checkUserType = (metaData) =>
    api.checkUserType(metaData)
      .then(parseUserTypeData);

  const getStarFeedback = ({portfolioId, deviceType, starRating, feedbackCateg,feedbackText,logoutTriggered,clientAdvisorFlag,metaData}) =>
    api
    .getStarFeedback(portfolioId, deviceType, starRating, feedbackCateg,feedbackText,logoutTriggered,clientAdvisorFlag,metaData)
    .then(parseResponseData);

    return {
      getResponseJson,
      checkStarFeedback,
      checkUserType,
      getStarFeedback
    }
}

module.exports = serviceFactory;